import { useTranslation } from 'react-i18next';
import { Button, Dropdown, DropdownTrigger, DropdownTriggerContext } from '@digdir/designsystemet-react';
import { ChevronDownIcon } from '@navikt/aksel-icons';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUser } from '../../../../hooks/useUser';
import { useAuthentication } from '../../../../hooks/useAuthentication';
import { DropDownButton } from '../../../../screens/building/pages/energiplan/styledComponents';

export const UserMenu = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const { signIn, signOut, isAuthenticated } = useAuthentication();

  if (!isAuthenticated || !user) {
    return (
      <Button variant="tertiary" onClick={() => signIn()}>
        {t('logIn')}
      </Button>
    );
  }

  const navigateToProfile = () => {
    navigate('/profil');
    setOpen(false);
  };

  const onLogout = async () => {
    await signOut();
    setOpen(false);
  };

  return (
    <DropdownTriggerContext>
      <DropdownTrigger variant="tertiary">
        {user?.navn}
        <ChevronDownIcon aria-hidden />
      </DropdownTrigger>
      <Dropdown open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)}>
        <Dropdown.List>
          <Dropdown.Item>
            <DropDownButton onClick={navigateToProfile}>{t('mainScreen.tab.profil')}</DropDownButton>
          </Dropdown.Item>
          <Dropdown.Item>
            <DropDownButton onClick={onLogout}>{t('logOut')}</DropDownButton>
          </Dropdown.Item>
        </Dropdown.List>
      </Dropdown>
    </DropdownTriggerContext>
  );
};
